export const defaultTranslation = `
### Hint:
You can always reopen this information by clicking the "info" icon in the top right corner (near the language chooser)

---
## Instructions
#### How to use the card tool:
1. Compose your own text wherever it says “Your text here”
2. Enter the name(s) of the "signatories" - the names are displayed in the standard "handwriting" font. You can enter up to six names and, if you wish, job titles.
3. Click on "Copy card to e-mail".
4. Open Outlook and paste into empty e-mail
5. Send off your greetings!


---
## Anleitung
#### Wie man das Karten-Tool nutzt: 
1. Fügen Sie nach Belieben Ihre Grüße überall dort ein, wo „Ihr Text hier“ steht
2. Geben Sie den/die Namen des/der „Unterzeichnenden“ ein - die Namen werden in der Standardschriftart „Handschrift“ angezeigt. Sie können insgesamt bis zu sechs Namen und, wenn gewünscht, Jobtitel eingeben. 
3. Klicken Sie auf „Karte in E-Mail kopieren“.
4. Outlook öffnen und in leere E-Mail einfügen
5. Schicken Sie Ihre Grüße ab!
`;